import type { Theme } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import type { ZIndex } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import { tsGoComponents } from './components';
import { tradeshiftThemeConfig } from './tradeshift-theme';
import { goPalette, tsGoTypography, tsGoUnit } from './tsGoThemeVars';

const defaultMobileTSUIbreakpoint = 650; // this is the switch from desktop to mobile on angularjs

const zIndex: Partial<ZIndex> = {
	// this commit  https://github.com/Tradeshift/tradeshift-mui/commit/0cd96e3328feebb8f96f45f553a1c15b60480d5a
	// introduces a breaking change, and we can not see the select option anymore
	// here we reset the drawer component z-index to the library default value
	drawer: 1200,
};

const goTheme = {
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: defaultMobileTSUIbreakpoint + 1,
			lg: 1200,
			xl: 1536,
		},
	},
	components: tsGoComponents,
	palette: goPalette,
	typography: tsGoTypography,
	tsGoUnit,
	zIndex,
} as const;

export const customGoTheme: Theme = createTheme(deepmerge(tradeshiftThemeConfig as Theme, goTheme));
